import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const LogActions = {
  downloadArchive (_, name) {
    return axiosRequest({
      url: `/admin/logs/archives/${name}`,
      method: 'get',
      responseType: 'blob',
    }).
      then(response => response).
      catch(handleError)
  },

  async exportLogs ({ commit }, search) {
    return axiosRequest.
      get('/admin/logs/export', { params: search }).
      then(({ data }) => commit('downloads/addDownloadRequest', data.download_id, { root: true })).
      catch(handleError)
  },

  async loadArchives ({ commit }, search) {
    return axiosRequest.
      get('/admin/logs/archives').
      then(({ data }) => commit('setArchives', data)).
      catch(handleError)
  },

  async loadLogs ({ commit }, search) {
    return axiosRequest.
      get('/admin/logs', { params: search }).
      then(({ data }) => commit('setLogs', data)).
      catch(handleError)
  },

  async loadLogsActors ({ commit }, search) {
    return axiosRequest.
      get('/admin/logs/actors').
      then(({ data }) => commit('setLogsActors', data)).
      catch(handleError)
  },
}
